import axios from 'axios';
import config from '../config/config';

// Create axios instance with configuration
const api = axios.create({
  baseURL: config.BASE_URL,
  timeout: config.TIMEOUT,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add request interceptor for authentication
api.interceptors.request.use(
  (config) => {
    // Add auth token from localStorage if available
    const token = localStorage.getItem('user') 
      ? JSON.parse(localStorage.getItem('user')).token 
      : null;
      
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    
    // Enhanced logging in DEBUG mode
    if (config.DEBUG) {
      console.error('[API Error]', error.message, {
        status: error.response?.status,
        url: originalRequest.url,
        method: originalRequest.method,
      });
    }
    
    // Handle 502 Bad Gateway errors specifically
    if (error.response && error.response.status === 502) {
      
      // Initialize retry count
      originalRequest._retry = (originalRequest._retry || 0) + 1;
      
      // Retry the request if we haven't reached the limit
      if (originalRequest._retry <= config.RETRY_ATTEMPTS) {
        
        // Use increasing delay for each retry attempt
        const delay = config.RETRY_DELAY * originalRequest._retry;
        await new Promise(resolve => setTimeout(resolve, delay));
        
        return api(originalRequest);
      } else {
        return Promise.resolve({
          data: {
            success: false,
            message: 'Server is currently unavailable. Please try again later.'
          }
        });
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;
